export function slidersExt() {

    if($(".main-slider").length > 0){
        $(".home-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            prevArrow: $(".prev-sl"),
            nextArrow: $(".next-sl"),
        });

        var bLazy_home_carousel = new Blazy({
            container: ".home-slider",
            selector: ".b-lazy",
            loadInvisible: true
        });

        $(".home-slider").on("afterChange", function(event, slick, direction){
            bLazy_home_carousel.revalidate();
        });
    }

    if($(".grid-events-mobile-slider").length > 0) {

        $(".grid-events-mobile-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            dots: true,
            variableWidth: true,
        });

        var bLazy_carousel = new Blazy({
            container: ".grid-events-mobile-slider", // Default is window
            selector: ".b-lazy",
            loadInvisible: true
        });

        $(".grid-events-mobile-slider").on("afterChange", function(event, slick, direction){
            bLazy_carousel.revalidate();
        });
    }

    if($(".related-posts-slider").length > 0) {

        $(".related-posts-slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            prevArrow: $(".prev-sls"),
            nextArrow: $(".next-sls"),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if($(".gallery-img").length > 0) {
        $(".chronicle-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            adaptiveHeight: true,
            asNavFor: ".chronicle-slider-nav"
        });

        $(".chronicle-slider-nav").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: ".chronicle-slider",
            centerMode: true,
            arrows: true,
            focusOnSelect: true,
            prevArrow: $(".prev-sl"),
            nextArrow: $(".next-sl"),
        });
    }

}


// WEBPACK FOOTER //
// ./assets/js/modules/sliders.js